import { getMasterData } from 'master-data'
import { Domains } from 'monitoring/constants/domains'
import { sendError } from 'monitoring/sendError/server/sendError'

import { Link, isValidInternalLinkHref } from '../Link'
import type { ServerLinkProps } from './types'

export function ServerLink(props: ServerLinkProps): React.ReactNode {
	const { href, logId } = props
	const masterData = getMasterData()

	if (!isValidInternalLinkHref(href)) {
		throw sendError({
			message: `Link(${logId}) with "${href}" url must start with a "/" on internal links`,
			domain: Domains.Link,
		})
	}

	return <Link {...props} masterData={masterData} />
}
